/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBallBowling = createReactComponent("ball-bowling", "IconBallBowling", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M11 9l0 .01", key: "svg-1" }],
  ["path", { d: "M15 8l0 .01", key: "svg-2" }],
  ["path", { d: "M14 12l0 .01", key: "svg-3" }]
]);

export { IconBallBowling as default };
//# sourceMappingURL=IconBallBowling.js.map
